import $ from 'jquery';
import _ from 'ext:lodash';
import Framework from 'framework';
import urlUtils from 'lib/url-utils';

function generateGetUrl(sso, profileToken, href, ssoParamName, forceSso, profileParamName) {
	var url = href;

	var params = {};
	if(sso){
		params[ssoParamName] = sso;
		url = urlUtils.appendQueryParam(params, url);
	}else if(forceSso === true) {
		url = Framework.getStore('UrlStore').getInitialData().globalPageDrivers.login + '?resource=' + encodeURIComponent(url);
	}else if(profileParamName && profileToken){
		params[profileParamName] = profileToken;
		url = urlUtils.appendQueryParam(params, url);
	}
	return url;
}

function handleClickEvent(element, evt) {
	var sso = Framework.getStore('ProfileStore').getInitialData().sso;
	var profileToken = Framework.getStore('ProfileStore').getInitialData().token;
	var partnerOrigHref = element.data('partner');
	var partnerType = element.data('partner-type');
	var ssoParamName = element.data('param-name');
	var forceSso = element.data('force-sso');
	var profileParamName = element.data('profile-param-name');
	var newWindow = element.data('new-window');
	var ignorePartnerConfig = element.data('ignore-partner-config');

	if(newWindow && !ignorePartnerConfig) {
		element.attr('target', '_blank');
	}
	// send user to partner servlet
	if(partnerType && partnerType === 'POST' && evt.type !== 'contextmenu' && (sso || profileToken)) {
		if(evt && ( evt.preventDefault || typeof evt.preventDefault === 'function' )) {
			evt.preventDefault();
		}
		var params = {};
		if(sso) {
			params[ssoParamName] = sso;
		}else if(profileParamName && profileToken){
			params[profileParamName] = profileToken;
		}
		urlUtils.postToUrl(partnerOrigHref, params);
	}else{
		// default to get request
		element.attr('href', generateGetUrl(sso, profileToken, partnerOrigHref, ssoParamName, forceSso, profileParamName));
	}
}

function initialize() {
	$('[data-partner]').each((index, item)=> {
		// bind click event for partner links
		$(item).bind({
			'click': function(evt) {
				handleClickEvent($(this), evt);
			},
			'contextmenu': function(evt) {
				handleClickEvent($(this), evt);
			}
		});
	});
}

export default initialize;

initialize();
